import React from 'react'
import { useIsResponsive } from '@/hooks'
import { EmtTypography, EmtSeparator } from 'emt-components-v2'
import Box from '@mui/material/Box'
import BackButton from './BackButton'

type Props = {
  title: string
}

const ContainerTitleNode: React.FC<Props> = ({ title }) => {
  const [isMobile] = useIsResponsive()

  return !isMobile ? (
    <EmtTypography variant="h3" fontWeight={800}>
      {title}
    </EmtTypography>
  ) : (
    <>
      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }} className="EmtReactNativeWebViewMarginTop">
        <BackButton />
        <EmtTypography variant="h4" fontWeight={800}>
          {title}
        </EmtTypography>
      </Box>
      <EmtSeparator />
    </>
  )
}

export default ContainerTitleNode
